import React,{useEffect,useState,useRef} from 'react';
import { Row, Col, Container, Accordion } from 'react-bootstrap';
import ProductListSidebar from '../ProductListSidebar';
import ProductListLeftbar from '../ProductListLeftbar';
import BrandLogoSlider from '../BrandLogoSlider';
import Axios from '../../lib/axios/axiosInstance';
import { useSelector, useDispatch } from 'react-redux'
import './ProductList.styles.css';

const ProductList = ({ baseUrl, url,productBasename }) => {
  
	const [products, setProducts] = useState(false);
	const [compareProductListUpdated, setCompareProductListUpdated] = useState(0);
	const [productBname, setProductBname] = useState(false);
  const colorFilter = useRef('');

  const compare = useSelector(state => state.compare);
  const dispatch = useDispatch();

  useEffect(() => {
    if(compare && compare>0){
      setCompareProductListUpdated(compare)
    }
  }, [compare])

  const getProducts = async () => {
  await Axios.get(url)
    .then(function (response) {
      if (response && response.status == 200) {
        var data=response.data?.data;
        setProducts(data??[]);
      }
    })
  };

  useEffect(() => {
    setProducts([])
    if(url)getProducts();
    if(productBasename)setProductBname(productBasename);
	}, [url])

  return (
    <>
      {/* <Breadcrumb /> */}
        <section className="main-container col2-left-layout">
          <Container>
            <Row>
              <Col sm={9}  md={9} lg={9} className="col-sm-push-3">
                {/* <CustomProductListSideBar/> */}
                <ProductListLeftbar searchList={true} products={products} productBasename={productBname} baseUrl={baseUrl} reducer={compare} dispatch={dispatch}/>
              </Col>
              <Col sm={3} md={3} xs={12} lg={3} className="col-sm-pull-9 sidebar">
                <ProductListSidebar showShopBy={false} leftSideData={false} compareProductListUpdated={compareProductListUpdated} dispatch={dispatch}/>
              </Col>
              <Col sm={12}>
                <BrandLogoSlider brand={products?.partner}/>
              </Col>
            </Row>
          </Container>
        </section>
    </>
  );
};

export default ProductList;
